import { Button, styled } from '@mui/material';
import download from './download.svg';

const CustomButton = styled(Button)(() => ({
  background: 'linear-gradient(90deg,  #046184,#01161E)',
  color: 'white',
  width: '226px',
  padding: '10px 20px',
  textTransform: 'none',
  fontSize: '16px',
  fontWeight: 500,
  borderRadius: '4px',
  display: 'flex',
  alignItems: 'center',
  gap: '8px',
  '&:hover': {
    background: 'linear-gradient(90deg,  #1A5EAD, #0A2C5A)',
    boxShadow: '0px 4px 8px rgba(0, 0, 0, 0.1)',
  },
}));

export default function DownloadButton({ onClick, className }) {
  return (
    <CustomButton
      variant="contained"
      onClick={onClick}
      className={className}
      endIcon={<img src={download} alt="download" />}
    >
      Download App
    </CustomButton>
  );
}
